import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () =>{
    try{
      const res = await API.post("/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("userId", res.data.user.id);
      localStorage.setItem("role", res.data.user.role);
      localStorage.setItem("userName", res.data.user.name);
      navigate("/dashboard");
    } 
    catch(error){
      alert(error.response?.data?.message || "Login failed. Check credentials.");
    }
  };

  return(
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Staff Login</h2>
        <div className="space-y-4">
          <input className="w-full border p-3 rounded-lg" placeholder="Email" onChange={e => setEmail(e.target.value)} />
          <input className="w-full border p-3 rounded-lg" type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
          
          <button onClick={handleLogin} className="w-full bg-blue-600 text-white p-3 rounded-lg font-bold hover:bg-blue-700">
            Login
          </button>

          <hr />

          {/*registeration option for users*/}
          <button onClick={() => navigate("/register")} className="w-full border border-blue-600 text-blue-600 p-3 rounded-lg hover:bg-blue-50">
            Register New Staff
          </button>

          {/*visitor portal*/}
          <button onClick={() => navigate("/visitor")} className="w-full bg-gray-800 text-white p-3 rounded-lg hover:bg-gray-900">
            Visitor Self-Service Portal
          </button>
        </div>
      </div>
    </div>
  );
}
export default Login;
